import { render, staticRenderFns } from "./ReportAccidentUpdate.vue?vue&type=template&id=189f03d8&scoped=true&"
import script from "./ReportAccidentUpdate.vue?vue&type=script&lang=js&"
export * from "./ReportAccidentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f03d8",
  null
  
)

export default component.exports